import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PendingSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PendingSVG;
